import React from 'react';
import { useTranslation } from 'react-i18next';
import CDNImage from '../../utils/CDNImage';
import classNames from 'classnames/bind';

import styles from './Testimonios.module.scss';

let cx = classNames.bind(styles);

const Testimonios = () => {
	const { t } = useTranslation();

	return (
		<section
			id='testimonios'
			className={cx({
				testimonios: true,
				'hidden lg:flex flex-col': true,
			})}
		>
			<div className='container p-10 text-tcn-red py-12 pb-32'>
				<h1 className='text-tcn-red font-bold uppercase font-Avenir-Black'>Testimonios DE</h1>
				<h1 className='text-tcn-red font-bold uppercase pb-20 font-Avenir-Black'>
					NUESTROS COLABORADORES
				</h1>
			</div>
			<div
				className={cx({
					area_image: true,
					'container mx-auto  px-10 lg:p-10 flex flex-col lg:flex-row items-center  p-32': true,
				})}
			>
				<div
					className={cx({
						testimonio: true,
						testimonio_1: true,
						'flex flex-col items-center justify-start w-12/12 lg:w-1/4 my-10 lg:m-12 text-center bg-tcn-red mt-24': true,
					})}
				>
					<CDNImage
						className={cx({ photo1: true, '': true })}
						image_name='Francisca_Morales.png'
						alt='Francisca_Morales'
					/>
					<h1 className='font-Avenir-Black'>Francisca Morales</h1>
					<h2 className={cx({ cargo: true, 'font-Avenir-Black': true })}>Seguridad & Protección</h2>
					<p className='text-left font-Avenir-Black'>
						“Durante casi 2 años en IDEAL me he podido desenvolver e integrar
						fácilmente en un área donde la mujer ha tomado relevancia sin
						existir diferencia de género. Veo mis resultados y me siento
						satisfecha y orgullosa de lo que he podido lograr con mi equipo de
						trabajo, siempre bajo la misión que somos una empresa altamente
						productiva y plenamente humana.”
					</p>
				</div>
				<div
					className={cx({
						testimonio: true,
						testimonio_2: true,
						'flex flex-col items-center justify-start w-12/12 lg:w-1/4 my-10 lg:m-12 text-center bg-tcn-dark-blue ': true,
					})}
				>
					<CDNImage
						className={cx({ photo2: true, '': true })}
						image_name='Nicole_Fuentes.png'
						alt='Nicole_Fuentes'
					/>
					<h1 className='font-Avenir-Black'>Nicole Fuentes</h1>
					<h2 className={cx({ cargo: true, 'font-Avenir-Black': true })}>Marketing</h2>
					<p className='text-left font-Avenir-Black'>
						“Pertenecer a la familia IDEAL ha sido un gran regalo de aprendizaje
						y crecimiento, recientemente asumí un nuevo desafío en el equipo de
						Marketing en cual acepté con mucho entusiasmo, actualmente me siento
						feliz de pertenecer a una compañía donde uno puede surgir y crecer.
						Realmente soy afortunada de poder hacer lo que me gusta en IDEAL.”
					</p>
				</div>
				<div
					className={cx({
						testimonio: true,
						testimonio_3: true,
						'flex flex-col items-center justify-start w-12/12 lg:w-1/4 my-10 lg:m-12 text-center  bg-tcn-light-blue': true,
					})}
				>
					<CDNImage
						className={cx({ photo3: true, '': true })}
						image_name='Ronaldo_Cabaña.png'
						alt='Ronaldo_Cabaña'
					/>
					<h1 className='font-Avenir-Black'>Ronaldo Cabaña</h1>
					<h2 className={cx({ cargo: true, 'font-Avenir-Black': true })}>Administración y Finanzas</h2>
					<p className='text-left font-Avenir-Black'>
						“A lo largo de los 4 años en IDEAL he podido desarrollarme en todos los ámbitos posibles. De hecho, me dieron la oportunidad de capacitarme directamente en México y esa fue una experiencia ideal.”
					</p>
				</div>
				<div
					className={cx({
						testimonio: true,
						testimonio_4: true,
						'flex flex-col items-center justify-start w-12/12 lg:w-1/4 my-10 lg:m-12 text-center  bg-tcn-cyan': true,
					})}
				>
					<CDNImage
						className={cx({ photo4: true, '': true })}
						image_name='Analicia_Ruiz.png'
						alt='Analicia_Ruiz'
					/>
					<h1 className='text-left text-tcn-dark-blue font-Avenir-Black'>Analicia Ruiz</h1>
					<h2 className={cx({ cargo: true, 'text-tcn-dark-blue font-Avenir-Black': true })}>
						Producción
					</h2>
					<p className='text-left text-tcn-dark-blue font-Avenir-Black'>
						“Llevo 25 años en la compañía, inicié como operaria de producción,
						actualmente me desempeño como Supervisora de Producción y solo puedo
						decir que me siento cada día más motivada de seguir aprendiendo. Hoy
						veo crecer a mis colaboradores y me reflejo en ellos, me siento
						orgullosa de ser parte de esta nueva época y del nuevo rol de la
						mujer en el mundo laboral.”
					</p>
				</div>
			</div>
		</section>
	);
};

export default Testimonios;
